export default {
  escalas: [],
  loading: false,
  // Utilizado para definir uma escala definida
  escala: { sigla: "CON" },
};
